<template>
	<div class="section">
		<div class="container is-large">
			<div class="section-body">
				<div class="section-left">
					<div
						class="section-description is-medium"
						:class="{ 'is-active-up' : !toggleSettings }"
						@click="toggleSettings = false"
					>
						Account settings
					</div>
					<div
						class="section-description is-medium"
						:class="{ 'is-active-down' : toggleSettings }"
						@click="toggleSettings = true"
					>
						Change Password
					</div>
				</div>
				<div class="section-right">
					<SettingsAccount v-if="!toggleSettings" />
					<SettingsPassword v-if="toggleSettings" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SettingsAccount from '@/components/SettingsAccount.vue';
import SettingsPassword from '@/components/SettingsPassword.vue';

export default {
	name: 'Account',

	components: {
		SettingsAccount,
		SettingsPassword,
	},

	data() {
		return {
			toggleSettings: false,
		};
	},
};
</script>

<style lang="scss" scoped>
.section {
	background-color: $color-black;
	color: $color-white;

	.section-subtitle {
		color: $color-accent-200;
		margin-top: $gap-4;
	}

	.section-description {
		color: $color-accent-300;
		font-weight: $fontWeight-regular;
		padding: $gap-2;
		cursor: pointer;

		&.is-active-up {
			color: $color-accent-100;
			background-color: $color-accent-600;
			border-radius: 3px 3px 0 0;
			border-bottom: 1px solid $color-accent-400;
		}

		&.is-active-down {
			color: $color-accent-100;
			background-color: $color-accent-600;
			border-radius: 0 0 3px 3px;
			border-top: 1px solid $color-accent-400;
		}
	}

	.section-body {
		display: flex;
		justify-content: space-between;
		margin-top: $gap-5;
	}

	.section-left {
		width: 20%;
		padding: $gap-5;
		display: flex;
		flex-direction: column;
	}

	.section-right {
		width: 60%;
		height: fit-content;
		background-color: $color-accent-600;
		padding: $gap-5;
		margin-right: $gap-5;
		border-radius: 6px;
	}
}
</style>
